import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from './services/auth.service';
import { AppService } from './services/app.service';
import { TranslationService } from './services/translation.service';
import { ErrorLoggerService } from './services/error-logger.service';
import { ValidationService } from './services/validation.service';
import { HttpService, ErrorHandlerService } from './services/http.service';
import { SettingsService } from './services/settings.service';
import { AutocompleteService } from './services/autocomplete.service';
import { CacheService } from './services/cache.service';
import { NotificationService } from './services/notification.service';

import { SmTranslatePipe } from './pipes/sm-translate.pipe';
import { SmTruncatePipe } from './pipes/sm-truncate.pipe';
import { SmFilterPipe } from './pipes/sm-filter.pipe';
import { SmGroupByPipe } from './pipes/sm-groupby.pipe';
import { SmUtcDatePipe } from './pipes/sm-utc-date.pipe';
import { SmLocalDatePipe } from './pipes/sm-local-date.pipe';
import { SmTranslateDirective } from './directives/sm-translate.directive';
import { SmNumberInputDirective } from './directives/sm-number-input.directive';
import { ControlMessagesComponent } from './components/sm-control-messages.component';
import { ControlWrapperComponent } from './components/sm-control-wrapper.component';
import { SmCheckboxItemComponent } from './components/sm-checkbox-item.component';
import { SmCheckboxGroupComponent } from './components/sm-checkbox-group.component';
import { SmRadioItemComponent } from './components/sm-radio-item.component';
import { SmRadioGroupComponent } from './components/sm-radio-group.component';

export { CoreValidators } from './validators';

@NgModule({
	imports: [CommonModule],
	declarations: [
		SmTranslatePipe,
		SmTruncatePipe,
		SmFilterPipe,
		SmGroupByPipe,
		SmUtcDatePipe,
		SmLocalDatePipe,
		SmTranslateDirective,
		SmNumberInputDirective,
		ControlMessagesComponent,
		ControlWrapperComponent,
		SmCheckboxItemComponent,
		SmCheckboxGroupComponent,
		SmRadioItemComponent,
		SmRadioGroupComponent
	],
	exports: [
		SmTranslatePipe,
		SmTruncatePipe,
		SmFilterPipe,
		SmGroupByPipe,
		SmUtcDatePipe,
		SmLocalDatePipe,
		SmTranslateDirective,
		SmNumberInputDirective,
		ControlMessagesComponent,
		ControlWrapperComponent,
		SmCheckboxItemComponent,
		SmCheckboxGroupComponent,
		SmRadioItemComponent,
		SmRadioGroupComponent
	]
})
export class CoreModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: CoreModule,
			providers: [
				AuthService,
				AppService,
				HttpService,
				TranslationService,
				ErrorLoggerService,
				ValidationService,
				SettingsService,
				AutocompleteService,
				CacheService,
				NotificationService,
				ErrorHandlerService
			]
		};
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/core.module.ts